(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-proof"] && !Shopify.designMode) return;
  try {
    
  class AtelierProof extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.tabs = [...this.querySelectorAll('[data-atelier-tab]')];
      this.panels = [...this.querySelectorAll('[data-atelier-panel]')];
      if (!this.panels.length) return;

      this.setAttribute('data-ready', '');
      this.querySelector('[data-atelier-tabs]').hidden = this.tabs.length < 2;
      this.activate(Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')));

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-atelier-tab]');
        if (tab) this.activate(this.tabs.indexOf(tab));
        const play = event.target.closest('[data-atelier-play]');
        if (play) play.closest('[data-atelier-panel]').querySelector('deferred-media')?.showDeferredMedia?.();
      }, { signal });

      this.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(event.target.closest('[data-atelier-tab]'));
        if (index < 0) return;
        const direction = this.matches(':dir(rtl)') ? -1 : 1;
        const next = {
          ArrowRight: (index + direction + this.tabs.length) % this.tabs.length,
          ArrowLeft: (index - direction + this.tabs.length) % this.tabs.length,
          Home: 0,
          End: this.tabs.length - 1,
        }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.activate(next, true);
      }, { signal });

      document.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-atelier-panel]');
        const index = this.panels.indexOf(panel);
        if (index >= 0) this.activate(index);
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.panels?.forEach((panel) => this.resetMedia(panel));
    }

    activate(index, focus = false) {
      if (!this.panels[index]) return;
      this.panels.forEach((panel, current) => {
        if (current !== index && !panel.hidden) this.resetMedia(panel);
        panel.hidden = current !== index;
        this.tabs[current].setAttribute('aria-selected', String(current === index));
        this.tabs[current].tabIndex = current === index ? 0 : -1;
      });
      if (focus) {
        this.tabs[index].focus({ preventScroll: true });
        this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    resetMedia(panel) {
      const media = panel.querySelector('deferred-media');
      if (!media?.hasAttribute('data-media-loaded')) return;
      media.pauseMedia();
      media.querySelectorAll('video, iframe').forEach((player) => player.remove());
      media.removeAttribute('data-media-loaded');
      media.querySelector('[ref="deferredMediaPlayButton"]')?.classList.remove('deferred-media__playing');
    }
  }

  if (!customElements.get('atelier-proof')) customElements.define('atelier-proof', AtelierProof);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-tabs')) {
    customElements.define('atelier-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.contains(tab)) this.select(tab);
        };
        this.onKeydown = (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0) return;
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.select(this.tabs[next]);
          this.tabs[next].focus();
        };
        this.onBlockSelect = (event) => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          const tab = this.tabs.find((item) => item.dataset.tabId === event.detail.blockId);
          if (tab) this.select(tab);
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      select(selected) {
        this.tabs.forEach((tab) => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.panelId !== selected.dataset.tabId; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-callout"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-open-personalization-popup]');
    if (!trigger) return;

    const popup = document.querySelector('personalized-steps-popup-component');
    popup?.openPopup?.();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
